import I18n from 'I18n';
export const CHARMAP_NAMESPACE = 'rich-text.charmap';
export const CHARMAP_STORE_KEYS = ['frequently', 'last'];
export const FREQUENTLY_USED_LIMIT = 14;
export const DEFAULT_FREQUENTLY_USED_CHARS = {
  169: 12,
  // Copyright
  174: 10,
  // Registered
  8482: 8,
  // Trademark
  60: 6,
  // less-than
  62: 4 // greater-than
};
export const CurrencyCodeMap = {
  USD: 36,
  CAD: 36,
  ARS: 36,
  AUD: 36,
  BND: 36,
  BRL: 36,
  BZD: 36,
  CLP: 36,
  COP: 36,
  CVE: 36,
  DOP: 36,
  HKD: 36,
  JMD: 36,
  MOP: 36,
  MXN: 36,
  NAD: 36,
  NIO: 36,
  NZD: 36,
  SGD: 36,
  SRD: 36,
  TOP: 36,
  TTD: 36,
  TWD: 36,
  UYU: 36,
  CNY: 20803,
  EUR: 8364,
  GBP: 163,
  GHS: 8373,
  AFN: 1547,
  BDT: 2547,
  CRC: 8353,
  KZT: 8376,
  JPY: 165,
  ILS: 8362,
  INR: 8377,
  IRR: 65020,
  KHR: 6107,
  KRW: 8361,
  MNT: 8366,
  NGN: 8358,
  NPR: 2344,
  PHP: 8369,
  PKR: 8360,
  PYG: 8370,
  THB: 3647,
  TRY: 8356,
  UAH: 8372,
  VND: 8363,
  AZN: 8380,
  RUB: 8381
};
const translatedLabel = label => I18n.text(`RichTextLib.charmap.characters.${label}`);
// All the special characters indexed by category name
// Each string is the translated label of the character description
// Original items taken from https://github.com/tinymce/tinymce/blob/master/modules/tinymce/src/plugins/charmap/main/ts/core/CharMap.ts
export const getCharmap = () => ({
  arrows: [{
    charCode: 8592,
    label: translatedLabel('leftwards')
  }, {
    charCode: 8593,
    label: translatedLabel('upwards')
  }, {
    charCode: 8594,
    label: translatedLabel('rightwards')
  }, {
    charCode: 8595,
    label: translatedLabel('downwards')
  }, {
    charCode: 8596,
    label: translatedLabel('leftRight')
  }, {
    charCode: 8629,
    label: translatedLabel('carriageReturn')
  }, {
    charCode: 8656,
    label: translatedLabel('leftwardsDouble')
  }, {
    charCode: 8657,
    label: translatedLabel('upwardsDouble')
  }, {
    charCode: 8658,
    label: translatedLabel('rightwardsDouble')
  }, {
    charCode: 8659,
    label: translatedLabel('downwardsDouble')
  }, {
    charCode: 8660,
    label: translatedLabel('leftRightDouble')
  }],
  currency: [{
    charCode: 36,
    label: translatedLabel('dollarSign')
  }, {
    charCode: 8364,
    label: translatedLabel('euroSign')
  }, {
    charCode: 163,
    label: translatedLabel('poundSign')
  }, {
    charCode: 165,
    label: translatedLabel('yenSign')
  }, {
    charCode: 162,
    label: translatedLabel('centSign')
  }, {
    charCode: 164,
    label: translatedLabel('currencySign')
  }, {
    charCode: 8352,
    label: translatedLabel('euroCurrencySign')
  }, {
    charCode: 8353,
    label: translatedLabel('colonSign')
  }, {
    charCode: 1547,
    label: translatedLabel('afghaniSign')
  }, {
    charCode: 2547,
    label: translatedLabel('bangladeshiTakasSign')
  }, {
    charCode: 8354,
    label: translatedLabel('cruzeiroSign')
  }, {
    charCode: 8355,
    label: translatedLabel('frenchFrancSign')
  }, {
    charCode: 8356,
    label: translatedLabel('liraSign')
  }, {
    charCode: 8357,
    label: translatedLabel('millSign')
  }, {
    charCode: 8358,
    label: translatedLabel('nairaSign')
  }, {
    charCode: 8361,
    label: translatedLabel('wonSign')
  }, {
    charCode: 8362,
    label: translatedLabel('newSheqelSign')
  }, {
    charCode: 8363,
    label: translatedLabel('dongSign')
  }, {
    charCode: 8365,
    label: translatedLabel('kipSign')
  }, {
    charCode: 8366,
    label: translatedLabel('tugrikSign')
  }, {
    charCode: 8367,
    label: translatedLabel('drachmaSign')
  }, {
    charCode: 8368,
    label: translatedLabel('germanPenny')
  }, {
    charCode: 8369,
    label: translatedLabel('pesoSign')
  }, {
    charCode: 8370,
    label: translatedLabel('guaraniSign')
  }, {
    charCode: 8371,
    label: translatedLabel('australSign')
  }, {
    charCode: 8372,
    label: translatedLabel('hryvniaSign')
  }, {
    charCode: 8373,
    label: translatedLabel('cediSign')
  }, {
    charCode: 8374,
    label: translatedLabel('livreTournoisSign')
  }, {
    charCode: 8376,
    label: translatedLabel('tengeSign')
  }, {
    charCode: 65020,
    label: translatedLabel('iranianRialSign')
  }, {
    charCode: 8378,
    label: translatedLabel('turkishLiraSign')
  }, {
    charCode: 6107,
    label: translatedLabel('cambodianRielSign')
  }, {
    charCode: 3647,
    label: translatedLabel('thaiBahtSign')
  }, {
    charCode: 2344,
    label: translatedLabel('nepaleseRupeeSign')
  }, {
    charCode: 8377,
    label: translatedLabel('indianRupeeSign')
  }, {
    charCode: 8360,
    label: translatedLabel('pakistaniRupeeSign')
  }, {
    charCode: 8359,
    label: translatedLabel('pesetaSign')
  }, {
    charCode: 8379,
    label: translatedLabel('nordicMarkSign')
  }, {
    charCode: 8380,
    label: translatedLabel('manatSign')
  }, {
    charCode: 8381,
    label: translatedLabel('rubleSign')
  }, {
    charCode: 20870,
    label: translatedLabel('yenCharacter')
  }, {
    charCode: 20803,
    label: translatedLabel('yuanCharacter')
  }, {
    charCode: 22291,
    label: translatedLabel('yuanCharacter2')
  }, {
    charCode: 22278,
    label: translatedLabel('yenYuanCharacterVariant')
  }],
  latin: [{
    charCode: 192,
    label: 'A - grave'
  }, {
    charCode: 193,
    label: 'A - acute'
  }, {
    charCode: 194,
    label: 'A - circumflex'
  }, {
    charCode: 195,
    label: 'A - tilde'
  }, {
    charCode: 196,
    label: 'A - diaeresis'
  }, {
    charCode: 197,
    label: 'A - ring above'
  }, {
    charCode: 256,
    label: 'A - macron'
  }, {
    charCode: 198,
    label: 'ligature AE'
  }, {
    charCode: 199,
    label: 'C - cedilla'
  }, {
    charCode: 200,
    label: 'E - grave'
  }, {
    charCode: 201,
    label: 'E - acute'
  }, {
    charCode: 202,
    label: 'E - circumflex'
  }, {
    charCode: 203,
    label: 'E - diaeresis'
  }, {
    charCode: 274,
    label: 'E - macron'
  }, {
    charCode: 204,
    label: 'I - grave'
  }, {
    charCode: 205,
    label: 'I - acute'
  }, {
    charCode: 206,
    label: 'I - circumflex'
  }, {
    charCode: 207,
    label: 'I - diaeresis'
  }, {
    charCode: 298,
    label: 'I - macron'
  }, {
    charCode: 208,
    label: 'ETH'
  }, {
    charCode: 209,
    label: 'N - tilde'
  }, {
    charCode: 210,
    label: 'O - grave'
  }, {
    charCode: 211,
    label: 'O - acute'
  }, {
    charCode: 212,
    label: 'O - circumflex'
  }, {
    charCode: 213,
    label: 'O - tilde'
  }, {
    charCode: 214,
    label: 'O - diaeresis'
  }, {
    charCode: 216,
    label: 'O - slash'
  }, {
    charCode: 332,
    label: 'O - macron'
  }, {
    charCode: 338,
    label: 'ligature OE'
  }, {
    charCode: 352,
    label: 'S - caron'
  }, {
    charCode: 217,
    label: 'U - grave'
  }, {
    charCode: 218,
    label: 'U - acute'
  }, {
    charCode: 219,
    label: 'U - circumflex'
  }, {
    charCode: 220,
    label: 'U - diaeresis'
  }, {
    charCode: 362,
    label: 'U - macron'
  }, {
    charCode: 221,
    label: 'Y - acute'
  }, {
    charCode: 376,
    label: 'Y - diaeresis'
  }, {
    charCode: 562,
    label: 'Y - macron'
  }, {
    charCode: 222,
    label: 'THORN'
  }, {
    charCode: 224,
    label: 'a - grave'
  }, {
    charCode: 225,
    label: 'a - acute'
  }, {
    charCode: 226,
    label: 'a - circumflex'
  }, {
    charCode: 227,
    label: 'a - tilde'
  }, {
    charCode: 228,
    label: 'a - diaeresis'
  }, {
    charCode: 229,
    label: 'a - ring above'
  }, {
    charCode: 257,
    label: 'a - macron'
  }, {
    charCode: 230,
    label: 'ligature ae'
  }, {
    charCode: 231,
    label: 'c - cedilla'
  }, {
    charCode: 232,
    label: 'e - grave'
  }, {
    charCode: 233,
    label: 'e - acute'
  }, {
    charCode: 234,
    label: 'e - circumflex'
  }, {
    charCode: 235,
    label: 'e - diaeresis'
  }, {
    charCode: 275,
    label: 'e - macron'
  }, {
    charCode: 236,
    label: 'i - grave'
  }, {
    charCode: 237,
    label: 'i - acute'
  }, {
    charCode: 238,
    label: 'i - circumflex'
  }, {
    charCode: 239,
    label: 'i - diaeresis'
  }, {
    charCode: 299,
    label: 'i - macron'
  }, {
    charCode: 240,
    label: 'eth'
  }, {
    charCode: 241,
    label: 'n - tilde'
  }, {
    charCode: 242,
    label: 'o - grave'
  }, {
    charCode: 243,
    label: 'o - acute'
  }, {
    charCode: 244,
    label: 'o - circumflex'
  }, {
    charCode: 245,
    label: 'o - tilde'
  }, {
    charCode: 246,
    label: 'o - diaeresis'
  }, {
    charCode: 248,
    label: 'o slash'
  }, {
    charCode: 333,
    label: 'o macron'
  }, {
    charCode: 339,
    label: 'ligature oe'
  }, {
    charCode: 353,
    label: 's - caron'
  }, {
    charCode: 249,
    label: 'u - grave'
  }, {
    charCode: 250,
    label: 'u - acute'
  }, {
    charCode: 251,
    label: 'u - circumflex'
  }, {
    charCode: 252,
    label: 'u - diaeresis'
  }, {
    charCode: 363,
    label: 'u - macron'
  }, {
    charCode: 253,
    label: 'y - acute'
  }, {
    charCode: 254,
    label: 'thorn'
  }, {
    charCode: 255,
    label: 'y - diaeresis'
  }, {
    charCode: 563,
    label: 'y - macron'
  }, {
    charCode: 913,
    label: 'Alpha'
  }, {
    charCode: 914,
    label: 'Beta'
  }, {
    charCode: 915,
    label: 'Gamma'
  }, {
    charCode: 916,
    label: 'Delta'
  }, {
    charCode: 917,
    label: 'Epsilon'
  }, {
    charCode: 918,
    label: 'Zeta'
  }, {
    charCode: 919,
    label: 'Eta'
  }, {
    charCode: 920,
    label: 'Theta'
  }, {
    charCode: 921,
    label: 'Iota'
  }, {
    charCode: 922,
    label: 'Kappa'
  }, {
    charCode: 923,
    label: 'Lambda'
  }, {
    charCode: 924,
    label: 'Mu'
  }, {
    charCode: 925,
    label: 'Nu'
  }, {
    charCode: 926,
    label: 'Xi'
  }, {
    charCode: 927,
    label: 'Omicron'
  }, {
    charCode: 928,
    label: 'Pi'
  }, {
    charCode: 929,
    label: 'Rho'
  }, {
    charCode: 931,
    label: 'Sigma'
  }, {
    charCode: 932,
    label: 'Tau'
  }, {
    charCode: 933,
    label: 'Upsilon'
  }, {
    charCode: 934,
    label: 'Phi'
  }, {
    charCode: 935,
    label: 'Chi'
  }, {
    charCode: 936,
    label: 'Psi'
  }, {
    charCode: 937,
    label: 'Omega'
  }, {
    charCode: 945,
    label: 'alpha'
  }, {
    charCode: 946,
    label: 'beta'
  }, {
    charCode: 947,
    label: 'gamma'
  }, {
    charCode: 948,
    label: 'delta'
  }, {
    charCode: 949,
    label: 'epsilon'
  }, {
    charCode: 950,
    label: 'zeta'
  }, {
    charCode: 951,
    label: 'eta'
  }, {
    charCode: 952,
    label: 'theta'
  }, {
    charCode: 953,
    label: 'iota'
  }, {
    charCode: 954,
    label: 'kappa'
  }, {
    charCode: 955,
    label: 'lambda'
  }, {
    charCode: 956,
    label: 'mu'
  }, {
    charCode: 957,
    label: 'nu'
  }, {
    charCode: 958,
    label: 'xi'
  }, {
    charCode: 959,
    label: 'omicron'
  }, {
    charCode: 960,
    label: 'pi'
  }, {
    charCode: 961,
    label: 'rho'
  }, {
    charCode: 962,
    label: 'final sigma'
  }, {
    charCode: 963,
    label: 'sigma'
  }, {
    charCode: 964,
    label: 'tau'
  }, {
    charCode: 965,
    label: 'upsilon'
  }, {
    charCode: 966,
    label: 'phi'
  }, {
    charCode: 967,
    label: 'chi'
  }, {
    charCode: 968,
    label: 'psi'
  }, {
    charCode: 969,
    label: 'omega'
  }],
  mathematical: [{
    charCode: 43,
    label: translatedLabel('plusSign')
  }, {
    charCode: 8722,
    label: translatedLabel('minusSign')
  }, {
    charCode: 247,
    label: translatedLabel('divisionSign')
  }, {
    charCode: 215,
    label: translatedLabel('multiplicationSign')
  }, {
    charCode: 8260,
    label: translatedLabel('fractionSlash')
  }, {
    charCode: 177,
    label: translatedLabel('plusMinusSign')
  }, {
    charCode: 176,
    label: translatedLabel('degreeSign')
  }, {
    charCode: 185,
    label: translatedLabel('superscriptOne')
  }, {
    charCode: 178,
    label: translatedLabel('superscriptTwo')
  }, {
    charCode: 179,
    label: translatedLabel('superscriptThree')
  }, {
    charCode: 188,
    label: translatedLabel('fractionQuarter')
  }, {
    charCode: 189,
    label: translatedLabel('fractionHalf')
  }, {
    charCode: 190,
    label: translatedLabel('fractionThreeQuarters')
  }, {
    charCode: 60,
    label: translatedLabel('lessThan')
  }, {
    charCode: 62,
    label: translatedLabel('greaterThan')
  }, {
    charCode: 8804,
    label: translatedLabel('lessThanEqualTo')
  }, {
    charCode: 8805,
    label: translatedLabel('greaterThanEqualTo')
  }, {
    charCode: 402,
    label: translatedLabel('functionFlorin')
  }, {
    charCode: 8747,
    label: translatedLabel('integral')
  }, {
    charCode: 8734,
    label: translatedLabel('infinity')
  }, {
    charCode: 8730,
    label: translatedLabel('squareRoot')
  }, {
    charCode: 8764,
    label: translatedLabel('similarTo')
  }, {
    charCode: 8773,
    label: translatedLabel('approximatelyEqualTo')
  }, {
    charCode: 8776,
    label: translatedLabel('almostEqualTo')
  }, {
    charCode: 8800,
    label: translatedLabel('notEqualTo')
  }, {
    charCode: 8801,
    label: translatedLabel('identicalTo')
  }, {
    charCode: 8712,
    label: translatedLabel('elementOf')
  }, {
    charCode: 8713,
    label: translatedLabel('notElementOf')
  }, {
    charCode: 8715,
    label: translatedLabel('containsAsMember')
  }, {
    charCode: 8721,
    label: translatedLabel('nArySummation')
  }, {
    charCode: 8719,
    label: translatedLabel('nAryProduct')
  }, {
    charCode: 8743,
    label: translatedLabel('logicalAnd')
  }, {
    charCode: 8744,
    label: translatedLabel('logicalOr')
  }, {
    charCode: 172,
    label: translatedLabel('notSign')
  }, {
    charCode: 8745,
    label: translatedLabel('intersection')
  }, {
    charCode: 8746,
    label: translatedLabel('union')
  }, {
    charCode: 8706,
    label: translatedLabel('partialDifferential')
  }, {
    charCode: 8704,
    label: translatedLabel('forAll')
  }, {
    charCode: 8707,
    label: translatedLabel('thereExists')
  }, {
    charCode: 8709,
    label: translatedLabel('diameter')
  }, {
    charCode: 8711,
    label: translatedLabel('backwardDifference')
  }, {
    charCode: 8727,
    label: translatedLabel('asteriskOperator')
  }, {
    charCode: 8901,
    label: translatedLabel('dotOperator')
  }, {
    charCode: 8733,
    label: translatedLabel('proportionalTo')
  }, {
    charCode: 8736,
    label: translatedLabel('angle')
  }, {
    charCode: 8834,
    label: translatedLabel('subsetOf')
  }, {
    charCode: 8835,
    label: translatedLabel('supersetOf')
  }, {
    charCode: 8836,
    label: translatedLabel('notSubsetOf')
  }, {
    charCode: 8838,
    label: translatedLabel('subsetEqualTo')
  }, {
    charCode: 8839,
    label: translatedLabel('supersetEqualTo')
  }, {
    charCode: 8853,
    label: translatedLabel('circledPlus')
  }, {
    charCode: 8855,
    label: translatedLabel('circledTimes')
  }, {
    charCode: 8869,
    label: translatedLabel('perpendicular')
  }, {
    charCode: 8968,
    label: translatedLabel('leftCeiling')
  }, {
    charCode: 8969,
    label: translatedLabel('rightCeiling')
  }, {
    charCode: 8970,
    label: translatedLabel('leftFloor')
  }, {
    charCode: 8971,
    label: translatedLabel('rightFloor')
  }],
  punctuation: [{
    charCode: 34,
    label: translatedLabel('quotationMark')
  }, {
    charCode: 8249,
    label: translatedLabel('singleLeftAngledQuotation')
  }, {
    charCode: 8250,
    label: translatedLabel('singleRightAngledQuotation')
  }, {
    charCode: 171,
    label: translatedLabel('leftGuillemet')
  }, {
    charCode: 187,
    label: translatedLabel('rightGuillemet')
  }, {
    charCode: 8216,
    label: translatedLabel('singleLeftQuotation')
  }, {
    charCode: 8217,
    label: translatedLabel('singleRightQuotation')
  }, {
    charCode: 8220,
    label: translatedLabel('doubleLeftQuotation')
  }, {
    charCode: 8221,
    label: translatedLabel('doubleRightQuotation')
  }, {
    charCode: 8218,
    label: translatedLabel('singleLowQuotation')
  }, {
    charCode: 8222,
    label: translatedLabel('doubleLowQuotation')
  }, {
    charCode: 8211,
    label: translatedLabel('enDash')
  }, {
    charCode: 8212,
    label: translatedLabel('emDash')
  }, {
    charCode: 175,
    label: translatedLabel('macron')
  }, {
    charCode: 8254,
    label: translatedLabel('overline')
  }, {
    charCode: 166,
    label: translatedLabel('brokenBar')
  }, {
    charCode: 168,
    label: translatedLabel('diaeresis')
  }, {
    charCode: 161,
    label: translatedLabel('invertedExclamationMark')
  }, {
    charCode: 191,
    label: translatedLabel('turnedQuestionMark')
  }, {
    charCode: 710,
    label: translatedLabel('circumflexAccent')
  }, {
    charCode: 732,
    label: translatedLabel('smallTilde')
  }, {
    charCode: 8242,
    label: translatedLabel('minutesFeet')
  }, {
    charCode: 8243,
    label: translatedLabel('secondsInches')
  }, {
    charCode: 37,
    label: translatedLabel('percentSign')
  }, {
    charCode: 8240,
    label: translatedLabel('perMilleSign')
  }, {
    charCode: 181,
    label: translatedLabel('microSign')
  }, {
    charCode: 183,
    label: translatedLabel('middleDot')
  }, {
    charCode: 8226,
    label: translatedLabel('bullet')
  }, {
    charCode: 8230,
    label: translatedLabel('threeDotLeader')
  }, {
    charCode: 167,
    label: translatedLabel('sectionSign')
  }, {
    charCode: 182,
    label: translatedLabel('paragraphSign')
  }, {
    charCode: 8756,
    label: translatedLabel('therefore')
  }, {
    charCode: 9001,
    label: translatedLabel('leftAngledBracket')
  }, {
    charCode: 9002,
    label: translatedLabel('rightAngledBracket')
  }],
  symbols: [{
    charCode: 169,
    label: translatedLabel('copyrightSign')
  }, {
    charCode: 174,
    label: translatedLabel('registeredSign')
  }, {
    charCode: 8482,
    label: translatedLabel('trademarkSign')
  }, {
    charCode: 8501,
    label: translatedLabel('alefSymbol')
  }, {
    charCode: 982,
    label: translatedLabel('piSymbol')
  }, {
    charCode: 8476,
    label: translatedLabel('realPartSymbol')
  }, {
    charCode: 978,
    label: translatedLabel('upsilonHookSymbol')
  }, {
    charCode: 8472,
    label: translatedLabel('weierstrass')
  }, {
    charCode: 8465,
    label: translatedLabel('imaginaryPart')
  }, {
    charCode: 8375,
    label: translatedLabel('spesmiloSign')
  }, {
    charCode: 180,
    label: translatedLabel('acuteAccent')
  }, {
    charCode: 184,
    label: translatedLabel('cedilla')
  }, {
    charCode: 170,
    label: translatedLabel('feminineOrdinal')
  }, {
    charCode: 186,
    label: translatedLabel('masculineOrdinal')
  }, {
    charCode: 8224,
    label: translatedLabel('dagger')
  }, {
    charCode: 8225,
    label: translatedLabel('doubleDagger')
  }, {
    charCode: 9674,
    label: translatedLabel('diamond')
  }, {
    charCode: 9824,
    label: translatedLabel('blackSpadeSuit')
  }, {
    charCode: 9827,
    label: translatedLabel('blackClubSuit')
  }, {
    charCode: 9829,
    label: translatedLabel('blackHeartSuit')
  }, {
    charCode: 9830,
    label: translatedLabel('blackDiamondSuit')
  }]
  // 'UNDEFINED': [
  // [160, label: translatedLabel('no-break space')},
  // [8194, label: translatedLabel('en space')},
  // [8195, label: translatedLabel('em space')},
  // [8201, label: translatedLabel('thin space')},
  // [8204, label: translatedLabel('zero width non-joiner')},
  // [8205, label: translatedLabel('zero width joiner')},
  // [8206, label: translatedLabel('left-to-right mark')},
  // [8207, label: translatedLabel('right-to-left mark')},
  //   ],
});